import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  async upload(request: RequestUpload): Promise<AxiosResponse<ResponseUpload>> {
    const response: AxiosResponse<ResponseUpload> = await client.post<ResponseUpload>('general_doc_photos', request, {
      headers: getAuthHeader()
    });
    return response;
  },

  async images(gpDocPhotoId: number): Promise<AxiosResponse<ResponseImages>> {
    const response: AxiosResponse<ResponseImages> = await client.get<ResponseImages>(
      `general_doc_photos/${gpDocPhotoId}/images`,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async confirm(gpDocPhotoId: number): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `general_doc_photos/${gpDocPhotoId}/update_confirmed_result`,
      {},
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface RequestUpload {
  imageBase64: string;
  pageNumber: number;
}

export interface ResponseUpload {
  generalDocPhotoId: number;
}

export interface ResponseImages {
  imageBase64: string;
}
